module.exports = __webpack_public_path__ + "static/media/img2-1.9757c0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/biosense/diff/img2-1.png
// module id = 1431
// module chunks = 3